import { useSupportDialogUnreadCountQuery } from 'src/entities/supportDialog';
import { useSoundOnUnreadIncrease, useUnlockAudioOnInteraction } from 'src/shared/notification';
import { useSupportDialogRealtime } from './useSupportDialogRealtime';

export const useSupportDialogNotifications = (): void => {
  const { count, isReady } = useSupportDialogUnreadCountQuery();

  useSupportDialogRealtime();
  useSoundOnUnreadIncrease(count, isReady);
  useUnlockAudioOnInteraction();
};